import { render, staticRenderFns } from "./setWhiteIP.vue?vue&type=template&id=796b96ae&"
import script from "./setWhiteIP.vue?vue&type=script&lang=js&"
export * from "./setWhiteIP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports